import { HeaderItem } from '@/types/headerItem';
import { Transaction } from '@/types/transaction';

type TransactionRow = Transaction;

export const createHeaders = (
  tr: (original: string) => string,
): readonly HeaderItem<TransactionRow>[] => [
  {
    label: tr('DATE'),
    sortable: true,
    key: 'date',
  },
  {
    label: tr('TYPE'),
    sortable: true,
    key: 'type',
  },
  {
    label: tr('METHOD'),
    sortable: false,
    key: 'paymentType',
  },
  {
    label: tr('AMOUNT'),
    sortable: false,
    key: 'fromAmount',
  },
  {
    label: tr('FROM'),
    sortable: false,
    key: 'fromAccount',
  },
  {
    label: tr('TO'),
    sortable: false,
    key: 'toAccount',
  },
  {
    label: tr('STATUS'),
    sortable: false,
    key: 'status',
  },
];
